<template>
    <div>
        <div class="top-menu">
            <div class="top-menu-content">
                <router-link :to="'/'"><img class="icon" src="../../assets/logo/logo.svg"
                        onerror="this.onerror=null; this.src=logo.svg'"></router-link>

                <div class="menu-items">

                    <div v-for="item in items" :key="item.id">
                        <div class="dropdown">
                            <button class="dropdown-toggle hvr-underline-from-center ">

                                <router-link v-if="item.path != null" :to="item.path">
                                    <span class="menu-item">{{ item.title.toUpperCase() }}</span>
                                </router-link>
                                <span class="menu-item" v-else>{{ item.title }}</span>

                            </button>
                            <div class="dropdown-menu" v-if="item.subitems && item.subitems.length > 0">
                                <div class="dropdown-subitems-wrapper">
                                    <div class="subitem" v-for="subitem in item.subitems" :key="subitem.id"><router-link
                                            class="subitem-link" :to="subitem.path">{{ subitem.title
                                            }}</router-link></div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-registrace">
                        <button class="dropdown-toggle-registrace">
                            <router-link style="text-decoration: none;" :to="'/registrace'">
                                <span class="menu-item">STAŇTE SE ČLENEM</span>
                            </router-link>
                        </button>
                    </div>

                </div>

                        

                <div class="menu-button" :class="{ 'open': isSideMenuOpen }" @click="toggleSideMenu">
                    <img class="side-menu-button" src="../../assets/icons/menu.svg" />
                </div>
            </div>
        </div>

        <div class="side-menu" :class="{ 'open': isSideMenuOpen }">
            <div class="close-button" @click="toggleSideMenu">
                <button>Zavřít</button>

            </div>
            <div v-for="item in items" :key="item.id">
                <p v-if="item.path != null" class="side-menu-subitem" @click="toggleItem(item)"> <router-link
                        :to="item.path">{{ item.title }}</router-link></p>
                <p class="side-menu-subitem" v-for="subitem in item.subitems" :key="subitem.id">
                    <router-link :to="subitem.path">{{ subitem.title }}</router-link>

                </p>
            </div>

            <button class="dropdown-toggle-registrace sidemenu-registrace">
                            <router-link style="text-decoration: none; " :to="'/registrace'">
                                <span class="menu-item">STAŇTE SE ČLENEM</span>
                            </router-link>
                        </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isSideMenuOpen: false,
            items: [
                {
                    id: 1,
                    title: 'Úvod',
                    path: '/',
                    open: false
                },
                {
                    id: 2,
                    title: 'O NÁS',
                    open: false,
                    subitems: [
                        { id: 1, title: 'Historie ČZS', path: '/historie-czs' },
                        { id: 2, title: 'Stanovy ČZS', path: '/stanovy-czs' },
                        { id: 3, title: 'Výbor a ostatní orgány', path: '/vybor-czs' },
                    ],
                },
                {
                    id: 3,
                    title: 'PRO ČLENY',
                    open: false,
                    subitems: [
                        { id: 1, title: 'Pro členy', path: '/clenove/informace' },
                        { id: 2, title: 'Knihovna', path: '/clenove/knihovna' },
                    ],
                },
/*                                 {
                    id: 4,
                    title: 'PRO VEŘEJNOST',
                    open: false,
                    subitems: [
                        { id: 1, title: 'Pro učitele', path: '/verejnost/pro-ucitele' },
                    ],
                }, */
                {
                    id: 5,
                    title: 'PUBLIKACE',
                    open: false,
                    subitems: [
                        { id: 2, title: 'Acta Societatis Zoologicae Bohemicae', path: '/acta-societatis-zoologicae-bohemicae' },
                    ],
                },
            ],
        };
    },
    methods: {
        toggleItem(item) {
            item.open = true;
        },
        toggleSideMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen;
        }
    },
};
</script>

<style scoped>
.top-menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #94b325;
    margin-bottom: 25px;
    height: 100px;
}

.top-menu-content {
    width: 1000px;
    margin: 0px auto;
    display: flex;
    justify-content: space-evenly;
}

.container .buttons button {
    margin-left: 10px;
}

.logo {
    font-weight: bold;
}

.menu-items {
    display: flex;
    align-items: center;
    margin-right: 20px;
        justify-content: space-evenly;
}

a {
    text-decoration: none;
}

.menu-item {
    width: 100%;
    text-decoration: none;
    color: white;
    white-space: nowrap;
    display: inline-block;
}

.dropdown {
    position: relative;
}

.dropdown-toggle {
    padding: 10px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-decoration: none;
}

.dropdown-toggle-registrace {
    padding: 10px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-decoration: none;
    background-color: #2f6508;
    margin-left: 15px;
}

.sidemenu-registrace {
   width: 200px;
   margin-top: 20px;
}

.dropdown-toggle:hover {
    background-color: rgba(255, 255, 255, 0.25);
}

.dropdown-toggle-registrace:hover {
    background-color: #4d8b20
}

.dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    display: none;
    white-space: nowrap;
    background-color: #FFF;
    border-radius: 0 5px 5px 5px;
}

.dropdown-subitems-wrapper {
    display: flex;
    flex-direction: column;
}

.subitem-link {
    text-decoration: none;
    color: #323232;
}

.subitem {
    padding: 15px;
    font-size: 15px;
    font-weight: bold;
    color: black;
    /* Remove underline */
}

.subitem:hover {
    background-color: #e2e2e2;
}

.dropdown:hover .dropdown-menu {
    display: block;
}

.side-menu {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background-color: #94b325;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;


  z-index: 10;

}

.side-menu {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background-color: #94b325;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    overflow: auto;
    box-shadow: -5px 0 5px -5px rgba(0, 0, 0, 0.2);
}

.side-menu.open {
    transform: translateX(0);
}

.side-menu-button {
    cursor: pointer;
    width: 25px;
    height: 25px;
    margin: 25px;
}

.side-menu-item {
    font-size: 16px;
    color: white;
    margin: 15px;
}

.side-menu-item a {
    color: white;
}

.side-menu-subitem a {
    color: white;
}



.side-menu-subitem {
    font-size: 16px;
    color: white;
    padding: 15px;
}

.side-menu-subitem:hover {
    background-color: rgba(255, 255, 255, 0.25);
}

.close-button {
    text-align: right;
    margin: 15px;
}

.close-button button {
    padding: 5px 10px;
    border: none;
    background-color: transparent;
    cursor: pointer;
}

.menu-button {
    display: none;
}

button {
    position: relative;
    overflow: hidden;
    transition: color 0.5s ease;
    font-size: 14px;
    font-weight: bold;
    color: #FFF;
    border-radius: 5px;
}

/* Underline From Center */
.hvr-underline-from-center {
    display: inline-block;
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    position: relative;
    overflow: hidden;
}

.hvr-underline-from-center:before {
    content: "";
    position: absolute;
    z-index: -1;
    left: 51%;
    right: 51%;
    bottom: 0;
    background: #2f6508;
    height: 4px;
    -webkit-transition-property: left, right;
    transition-property: left, right;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
}

.hvr-underline-from-center:hover:before,
.hvr-underline-from-center:focus:before,
.hvr-underline-from-center:active:before {
    left: 0;
    right: 0;
}

/* Radial Out */
.hvr-radial-out {
    display: inline-block;
    vertical-align: middle;
    -webkit-transform: perspective(1px) translateZ(0);
    transform: perspective(1px) translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    position: relative;
    overflow: hidden;
    -webkit-transition-property: color;
    transition-property: color;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
}

.hvr-radial-out:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 100%;
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transition-property: transform;
    transition-property: transform;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
}

.hvr-radial-out:hover,
.hvr-radial-out:focus,
.hvr-radial-out:active {
    color: white;
}

.hvr-radial-out:hover:before,
.hvr-radial-out:focus:before,
.hvr-radial-out:active:before {
    -webkit-transform: scale(2);
    transform: scale(2);
}

.icon{ 
        margin-left: 10px;
        width: 75%;
    }

@media (max-width: 768px) {
    .top-menu {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .menu-items {
        display: none;
    }

    .side-menu {
        display: block;
    }

    .menu-button {
        display: block;
    }

    .icon{ 
        margin-left: 10px;
        width: 70%;
    }

    .top-menu-content {
 align-items: center;
}
}
</style>